import { Box, Stack, Typography } from '@mui/material';
import type { ExternalProjectImportPreview } from '@provision/entity-types';
import { type ImportCountTense, totalImportCount } from './import-results.utils';

const ENTITIES = [
  { key: 'sites', label: 'Sites' },
  { key: 'clients', label: 'Clients' },
  { key: 'projects', label: 'Projects' },
] as const;

interface ImportSummaryProps {
  /** The first line, e.g. how many projects the step is about. */
  status: string;
  /** Leave out to show the status alone, e.g. while the job still runs. */
  records?: ExternalProjectImportPreview[];
  tense: ImportCountTense;
  /** Prefix of each count's test id: `-total-sites`, `-total-clients`, `-total-projects`. */
  testId: string;
}

/** The plain lines above an import list: where the import stands, then the counts per entity. */
export const ImportSummary = ({ status, records, tense, testId }: ImportSummaryProps) => {
  const totals = records ? totalImportCount(records, tense) : undefined;

  return (
    <Stack gap={0.25}>
      <Typography variant="body2" color="text.secondary">
        {status}
      </Typography>
      {totals ? (
        <Typography variant="body2" color="text.secondary">
          {ENTITIES.map(({ key, label }, index) => (
            <Box component="span" key={key}>
              {index > 0 ? ' · ' : null}
              {`${label} `}
              <Box
                component="span"
                color="text.primary"
                data-testid={`${testId}-total-${key}`}
              >
                {totals[key]}
              </Box>
            </Box>
          ))}
        </Typography>
      ) : null}
    </Stack>
  );
};
